import type { Template } from "@/types";

export const PO_07_H1_V6: Template[] = [
{
    id: "po-07-h1v6-01",
    name: "PO 01 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 31, y: 229, width: 554, height: 393, rotation: 0, imageRotation: 0 },
            { id: "2", x: 633, y: 137, width: 179, height: 285, rotation: 0, imageRotation: 0 },
            { id: "3", x: 820, y: 137, width: 179, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1007, y: 137, width: 179, height: 285, rotation: 0, imageRotation: 0 },
            { id: "5", x: 633, y: 431, width: 179, height: 284, rotation: 0, imageRotation: 0 },
            { id: "6", x: 820, y: 431, width: 179, height: 284, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1007, y: 431, width: 179, height: 284, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-02",
    name: "PO 02 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 50, y: 160, width: 509, height: 337, rotation: 0, imageRotation: 0 },
        { id: "2", x: 50, y: 505, width: 122, height: 185, rotation: 0, imageRotation: 0 },
        { id: "3", x: 180, y: 505, width: 121, height: 185, rotation: 0, imageRotation: 0 },
        { id: "4", x: 309, y: 505, width: 121, height: 185, rotation: 0, imageRotation: 0 },
        { id: "5", x: 438, y: 505, width: 121, height: 185, rotation: 0, imageRotation: 0 },
        { id: "6", x: 659, y: 225, width: 250, height: 401, rotation: 0, imageRotation: 0 },
        { id: "7", x: 917, y: 225, width: 249, height: 401, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-03",
    name: "PO 03 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 108, y: 122, width: 397, height: 289, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 108, y: 419, width: 195, height: 309, rotation: 0, imageRotation: 0 },
        { id: "3", x: 311, y: 419, width: 194, height: 309, rotation: 0, imageRotation: 0 },
        { id: "4", x: 653, y: 122, width: 370, height: 607, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1031, y: 122, width: 131, height: 197, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1031, y: 327, width: 131, height: 197, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1031, y: 532, width: 131, height: 196, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-04",
    name: "PO 04 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_04.png",
    size: [1217, 851],
    style: {},
    slots: [      
        { id: "1", x: 136, y: 166, width: 165, height: 255, rotation: 0, imageRotation: 0 },
        { id: "2", x: 309, y: 166, width: 165, height: 255, rotation: 0, imageRotation: 0 },
        { id: "3", x: 136, y: 429, width: 165, height: 255, rotation: 0, imageRotation: 0 },
        { id: "4", x: 309, y: 429, width: 165, height: 255, rotation: 0, imageRotation: 0 },
        { id: "5", x: 651, y: 166, width: 269, height: 518, rotation: 0, imageRotation: 0 },
        { id: "6", x: 928, y: 166, width: 238, height: 167, rotation: 0, imageRotation: 0 },
        { id: "7", x: 928, y: 341, width: 238, height: 342, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-05",
    name: "PO 05 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 50, y: 245, width: 509, height: 361, rotation: 0, imageRotation: 0 },
        { id: "2", x: 694, y: 112, width: 146, height: 204, rotation: 0, imageRotation: 0 },      
        { id: "3", x: 694, y: 324, width: 146, height: 204, rotation: 0, imageRotation: 0 },
        { id: "4", x: 694, y: 536, width: 146, height: 203, rotation: 0, imageRotation: 0 },
        { id: "5", x: 848, y: 112, width: 146, height: 204, rotation: 0, imageRotation: 0 },
        { id: "6", x: 848, y: 324, width: 299, height: 415, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1002, y: 112, width: 145, height: 204, rotation: 0, imageRotation: 0 }
       
    ],
},

{
    id: "po-07-h1v6-06",
    name: "PO 06 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 47, y: 116, width: 515, height: 351, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 475, width: 167, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 222, y: 475, width: 167, height: 259, rotation: 0, imageRotation: 0 },
            { id: "4", x: 397, y: 475, width: 166, height: 259, rotation: 0, imageRotation: 0 },
            { id: "5", x: 652, y: 158, width: 344, height: 535, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1004, y: 159, width: 168, height: 263, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1004, y: 431, width: 168, height: 262, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-07",
    name: "PO 07 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 128, y: 58, width: 235, height: 364, rotation: 0, imageRotation: 0 },
        { id: "2", x: 371, y: 58, width: 235, height: 364, rotation: 0, imageRotation: 0 },
        { id: "3", x: 614, y: 58, width: 234, height: 364, rotation: 0, imageRotation: 0 },
        { id: "4", x: 856, y: 58, width: 234, height: 364, rotation: 0, imageRotation: 0 },
        { id: "5", x: 128, y: 430, width: 235, height: 363, rotation: 0, imageRotation: 0 },
        { id: "6", x: 856, y: 430, width: 234, height: 363, rotation: 0, imageRotation: 0 },
        { id: "7", x: 371, y: 430, width: 477, height: 363, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-08",
    name: "PO 08 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_08.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 0, y: 171, width: 152, height: 251, rotation: 0, imageRotation: 0 },
        { id: "2", x: 160, y: 171, width: 152, height: 251, rotation: 0, imageRotation: 0 },
        { id: "3", x: 320, y: 171, width: 151, height: 251, rotation: 0, imageRotation: 0 },
        { id: "4", x: 0, y: 430, width: 152, height: 250, rotation: 0, imageRotation: 0 },
        { id: "5", x: 160, y: 430, width: 152, height: 250, rotation: 0, imageRotation: 0 },
        { id: "6", x: 320, y: 430, width: 151, height: 250, rotation: 0, imageRotation: 0 },
        { id: "7", x: 479, y: 171, width: 737, height: 509, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-09",
    name: "PO 09 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_09.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 548, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 667, y: 185, width: 484, height: 330, rotation: 0, imageRotation: 0 },
            { id: "3", x: 667, y: 523, width: 91, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 766, y: 523, width: 90, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 864, y: 523, width: 90, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 962, y: 523, width: 90, height: 144, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1061, y: 523, width: 90, height: 144, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-10",
    name: "PO 10 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_10.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 64, y: 124, width: 127, height: 196, rotation: 0, imageRotation: 0 },
        { id: "2", x: 64, y: 328, width: 127, height: 196, rotation: 0, imageRotation: 0 },
        { id: "3", x: 64, y: 532, width: 127, height: 196, rotation: 0, imageRotation: 0 },
        { id: "4", x: 199, y: 124, width: 819, height: 604, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1026, y: 124, width: 127, height: 196, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1026, y: 328, width: 127, height: 196, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1026, y: 532, width: 127, height: 196, rotation: 0, imageRotation: 0 }
    ],
}
];